import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';

import Footer from '../../Components/Footer/Footer';
import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';
import Select from 'react-select';

import FuelTypeSelect from '../FuelTypes/FuelTypeSelect';
import OilOrder from './OilOrder';
import FuelOrder from './FuelOrder';
import OrderAttributes from './OrderAttributes';
import StartOrderButton from './ActionButtons/StartOrderButton';
import FuelMeterSelect from '../FuelMeters/FuelMeterSelect';
import { parse } from 'url';

class AssignOrderPage extends Component {
  constructor(props) {
    super(props);

    if (props.location.state === undefined || props.location.state.fboId === undefined) {
      this.goBack();
    }

    const parsedOrderId = parseInt(this.props.match.params.orderId, 10);
    const parseFboId = parseInt(props.location.state.fboId, 10);

    this.state = {
      fboId: parseFboId,
      id: parsedOrderId,
      usingNetwork: true,
      fuelMeterId: undefined,
      fuelOrder: undefined,
      orderNumber: undefined
    };

    this.handleAssign = this.handleAssign.bind(this);
    this.handleMeterSelected = this.handleMeterSelected.bind(this);
    this.goBack = this.goBack.bind(this);
    this.renderAssignForm = this.renderAssignForm.bind(this);
  }

  componentWillMount() {
    this.fetchData(this);
  }

  fetchData() {
    this.setState({ usingNetwork: true });
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${this.state.fboId}/orders/${this.state.id}`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    this.request = Api.get(endPoint, {
      headers: myHeaders,
    }, true).then((response) => {
      const order = response.order;
      const towOrderType = order.towOrder ? order.towOrder.type : undefined;
      const firstFuelOrder = order.fuelOrders[0];

      this.setState({
        id: order.id,
        order,
        fuelOrder: firstFuelOrder,
        orderNumber: order.orderNumber,
        usingNetwork: false,
      });
    });
  }

  async handleAssign() {
    try {
      this.setState({ usingNetwork: true });

      await this.postData();
      await this.postStart();

      this.setState({ usingNetwork: false });

      const { history } = this.props;
      history.push({ pathname: `/orders/${this.state.id}` });
    } catch (error) {
      this.notificationSystem.addNotification({
        message: `Unable to start Order ${error.message}`,
        level: 'error',
        position: 'bc',
      });
    }
  }

  postData() {
    const endPoint = `v1/fbos/${this.state.fboId}/orders/${this.state.id}`;
    const orderUpdate = {
      fuelOrders: [{
        id: this.state.fuelOrder.id,
        orderId: this.state.id,
        fuelMeterId: this.state.fuelMeterId,
        fuelTypeId: this.state.fuelOrder.fuelTypeId
      }]
    };

    return Api.get(endPoint, {
      method: 'PUT',
      body: JSON.stringify(orderUpdate),
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': Auth.getBearerToken(),
      },
    }, false).then(response => response.order);
  }

  postStart() {
    const endPoint = `v1/fbos/${this.state.fboId}/orders/${this.state.id}/transition/start`;

    return Api.get(endPoint, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': Auth.getBearerToken(),
      },
    }, false).then(response => response.order);
  }

  goBack() {
    const { history } = this.props;
    history.goBack();
  }

  handleMeterSelected(fuelMeterId) {
    this.setState({ fuelMeterId });
  }

  renderAssignForm() {
    let disableButton = this.state.usingNetwork || !this.state.fuelMeterId;
    return (
      <main className="page-content">
        <NotificationSystem ref={(node) => { this.notificationSystem = node; }} />
        <div className="normal-page-header">
          <h1 className="left">Assign fuel truck</h1>
          <div className="clear" />
        </div>
        <OrderAttributes order={this.state.order} />
        <div className="edit-form page-content-items">
          <FuelMeterSelect fboId={this.props.fboId} onSelectionComplete={this.handleMeterSelected} />
          <button
            type="button"
            className="btn btn-medium btn-primary"
            onClick={this.handleAssign}
            disabled={disableButton}
          >
            Assign
          </button>
          <button
            type="button"
            className="btn btn-medium btn-alternative-options"
            onClick={this.goBack}
            disabled={this.state.usingNetwork}
          >
            Cancel
          </button>
        </div>
      </main>
    );
  }

  render() {
    return (
      <div className="app">
        { this.renderAssignForm() }
      </div>
    );
  }
}

AssignOrderPage.propTypes = {
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      fboId: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

AssignOrderPage.stateTypes = {
  fboId: PropTypes.number.isRequired,
};
export default AssignOrderPage;




// WEBPACK FOOTER //
// ./src/Containers/Orders/AssignOrderPage.js